import { render, staticRenderFns } from "./RejectDialog.vue?vue&type=template&id=0deef508"
import script from "./RejectDialog.vue?vue&type=script&lang=js"
export * from "./RejectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports